import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FsMessage, MessageMode } from '@firestitch/message';

import { AclService } from '@app/core/services';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard  {

  constructor(
    private _aclQueryService: AclService,
    private _router: Router,
    private _message: FsMessage) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): true | UrlTree {
    if (this._aclQueryService.hasPermissionAdmin()) {
      return true;
    }

    this._message.error('Sorry, but you haven\'t permission for this page',
      { mode: MessageMode.Toast });

    return this._router.createUrlTree(['/']);
  }

}
